import { createSlice } from "@reduxjs/toolkit";
const initialOfferSelectionState = {
  offerSelectedData: null,
  isLoading: false,
  location: "",
};
export const offerSelectionSlice = createSlice({
  name: "offerselection",
  initialState: initialOfferSelectionState,
  reducers: {
    setOfferSelectedData(state, action) {
      state.offerSelectedData = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setLocation(state, action) {
      state.location = action.payload;
    },
  },
});

export const { setOfferSelectedData, setIsLoading, setLocation } =
  offerSelectionSlice.actions;
